<h1 class="stock-title">Replenishment Stock - Showroom Capacity</h1>

<app-breadcrumb
  *ngIf="criteriaData"
  [externalData]="criteriaData"
></app-breadcrumb>

<br />
<br />
<!-- Spacer -->
<div class="mt-3"></div>

<div class="container-fluid align_filters">
  <div class="row mb-4 align-items-end">
    <div class="col-md-3">
      <ds-form-field>
        <label ds-label for="brandSelect" class="form-label">Brand</label>
        <ds-select
          id="brandSelect"
          [labellingConfig]="{ placeholder: 'Select a brand' }"
          [options]="brandOptions"
          [(ngModel)]="filters.brand"
          required
          [showClearAll]="true"
        ></ds-select>
      </ds-form-field>
    </div>
    <div class="col-md-3">
      <ds-form-field>
        <label ds-label for="storageLocationSelect" class="form-label">Storage Location</label>
        <ds-select
          id="storageLocationSelect"
          [labellingConfig]="{ placeholder: 'Select a location' }"
          [options]="storageLocationOptions"
          [(ngModel)]="filters.storageLocation"
          required
          [showClearAll]="true"
        ></ds-select>
      </ds-form-field>
    </div>
    <div class="col-md-3 align_search">
      <button
        ds-button
        ds-loading
        class="btn btn-primary mt-2"
        icon="search"
        (click)="callReplishCapacity()"
        [disabled]="!isSearchEnabled"
      >
        Search
      </button>
    </div>
  </div>
</div>

<div class="mt-3"></div>
<br />
<div class="content_bg_color">
  <div *ngIf="showResults; else notYetSearched">
    <ds-segmented-control [disabled]="true">
      <ds-segmented-control-item>
        CAPACITY: {{ response?.capacity || '-' }}
      </ds-segmented-control-item>
      <ds-segmented-control-item>
        ACTUALS: {{ response?.actualsTotal || '-' }}
      </ds-segmented-control-item>
      <ds-segmented-control-item>
        PENDING: {{ response?.pendingTotal || '-' }}
      </ds-segmented-control-item>
      <ds-segmented-control-item>
        ACCEPTED: {{ response?.acceptedTotal || '-' }}
      </ds-segmented-control-item>
      <ds-segmented-control-item>
        AVAILABLE: {{ response?.availableTotal || '-' }}
      </ds-segmented-control-item>
      <ds-segmented-control-item>
        IN SALES ORDER: {{ response?.soTotal || '-' }}
      </ds-segmented-control-item>
    </ds-segmented-control>

    <br />
    <div class="mt-3"></div>
    <br />

    <div class="content_bg styled-section">
      <table *ngIf="rowsData?.length" class="ds-table zebra-table fixed-header-table">
        <thead>
          <tr>
            <th *ngFor="let column of columnData">{{ column.headerName }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rowsData">
            <td *ngFor="let column of columnData">
              <ng-container [ngSwitch]="column.field">
                <ng-container *ngSwitchCase="'image'">
                    @if (row['image'] === '') {
                        <ds-progress-circle
                                size="sm"
                                class="image-loader"
                        ></ds-progress-circle>
                    } @else {
                  <div class="image-popup-wrapper">
                    <img
                      [src]="row['image']"
                      alt="Car"
                      class="car-image"
                      class="car-thumbnail"
                    />
                    <div class="image-hover-popup">
                      <img
                        [src]="row[column.field]"
                        alt="Vehicle Enlarged View"
                      />
                    </div>
                  </div>
                    }
                </ng-container>

                <ng-container *ngSwitchCase="'unitSalesOrder'">
                  <span
                    *ngIf="row['unitSalesOrder']"
                    [ngClass]="{
                      'dsp-yes':
                        row['unitSalesOrder'].toString().toLowerCase() ===
                        'yes',
                      'dsp-no':
                        row['unitSalesOrder'].toString().toLowerCase() === 'no',
                    }"
                    class="dsp-badge"
                  >
                    {{ row['unitSalesOrder'] }}
                  </span>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <!-- Dealer Actuals as link -->
                  <ng-container *ngIf="column.field === 'dealerActuals'">
                      <a
                              [href]="row[column.field] | unitOverviewLink"
                              target="_blank"
                              rel="noopener"
                              style="
                    font-weight: bold;
                    color: #037493;
                    text-decoration: none;
                    cursor: pointer;
                  "
                              title="View Unit Overview"
                      >
                      {{ row[column.field] }}
                    </a>
                  </ng-container>

                  <!-- Default text for everything else -->
                  <ng-container
                    *ngIf="
                      column.field !== 'vin' && column.field !== 'dealerActuals'
                    "
                  >
                    {{ row[column.field] }}
                  </ng-container>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
    </div>
  </div>
</div>
<ng-template #notYetSearched>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO SEARCH RESULTS YET</h1>
      <p style="margin: 0">
        Select Brand and Click Search to find what you need.
      </p>
    </div>
  </div>
</ng-template>
<ng-template #noStock>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO SEARCH RESULTS FOUND</h1>
      <p style="margin: 0">
        Try adjusting your search criteria in the filters.
      </p>
    </div>
  </div>
</ng-template>
